import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Order from "../../entity/b2csdu/Order";

const SERVICE = "service-b2csdu";
const ENTITY = "orders";

export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new Order(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.b2csdu?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                async exec() {
                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7");
                }
            }
        }
    }
}